export type MemberPriceLevelValue = number | 'svip' | 'none'

export const isSvipMemberPriceAvailable = (svipConfig?: { status?: boolean | number | null }) => !!svipConfig?.status

export const getMemberPriceSvipSelectionError = (memberLevelId?: MemberPriceLevelValue, svipEnabled = false) => {
    if (memberLevelId === 'svip' && !svipEnabled) return '请先开启付费会员后再选择付费会员'

    return ''
}
